import { render } from "./Ticket.vue?vue&type=template&id=34f00a82"
import script from "./Ticket.vue?vue&type=script&lang=ts"
export * from "./Ticket.vue?vue&type=script&lang=ts"
script.render = render

export default script